import { useContext } from 'react';
import { SharedOutputEditComponent } from './SharedInputEdit';
import { CalculatorFieldsContext, CalculatorOutputFieldsContext } from '../contexts/CalculatorContext';
import { CalculatorOutputFields } from '../utils/CalculatorOutputValue';
import { Column1 } from '../part/calculator-outputs/Column1';
import { Column3 } from '../part/calculator-outputs/Column3';
import { Column2 } from '../part/calculator-outputs/Column2';
import { CalculatorHtmModeContext } from '../../../shared/contexts/CalculatorContext';

export function CalculatorOutput(): JSX.Element {
    const [calculatorValue,] = useContext(CalculatorFieldsContext)!;
    const [calculatorMode,] = useContext(CalculatorHtmModeContext)!;
    const CalculatorOutputFieldsValues = new CalculatorOutputFields(calculatorValue, calculatorMode);

    return (
        <CalculatorOutputFieldsContext.Provider value={CalculatorOutputFieldsValues}>

            <article className="calculatorOutput">

                <h1>
                    <span className='acc-o-badge'>Calculator Output</span>
                </h1>

                <div className="card">

                    <SharedOutputEditComponent inputName="average_number_exam_hour"/>

                    <SharedOutputEditComponent inputName="average_number_exam_year"/>

                    <SharedOutputEditComponent inputName="estimated_revenue_year"/>

                    <SharedOutputEditComponent inputName="yearly_technologist_radiologist_wages"/>

                    <div className="inputValue"></div>
                    <div className="inputValue"></div>

                    <Column1/>
                    <Column2/>
                    <Column3/>

                </div>

            </article>

        </CalculatorOutputFieldsContext.Provider>
    );
}
